import { type ClassValue, clsx } from 'clsx';

/**
 * Utility function to merge and conditionally apply Tailwind CSS classes
 * This function combines clsx functionality for conditional classes
 * 
 * @param inputs - Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
} 